/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Stems_Select_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Unable to load the selected audio file." |
*
* @param {Audio_Stems_Select_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_stems_select_failed_toast = /** @type {((inputs?: Audio_Stems_Select_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Stems_Select_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de charger le fichier audio sélectionné.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die ausgewählte Audiodatei konnte nicht geladen werden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile caricare il file audio selezionato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось загрузить выбранный аудиофайл.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo cargar el archivo de audio seleccionado.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无法加载所选音频文件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択した音声ファイルを読み込めませんでした。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चुनी गई ऑडियो फ़ाइल लोड नहीं हो सकी।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foi possível carregar o ficheiro de áudio selecionado.")
	return /** @type {LocalizedString} */ ("Unable to load the selected audio file.")
});